import banner from 'sbf-design-system-component/banners/banner';
import Mustache from 'lib/mustache';
import Overlay from 'sbf-design-system-component/overlays/overlay';

function showPrivateEventWarning () {
  const id = $(this).attr('data-id');
  const year = $(this).attr('data-year');
  privateEventJoinUrl = `/register/participant/${id}/${year}`;
  privateEventCheckOverlay.show();
  return false;
}

let privateEventJoinUrl = '#';
const privateEventCheckOverlay = new Overlay($('#private_event_check_overlay'), {
  full_screen: true
});

$('.private-event').on('click.private', showPrivateEventWarning);

privateEventCheckOverlay.$el.on('overlay.afterHide', function () {
  privateEventJoinUrl = '#';
});

privateEventCheckOverlay.$el.find('.private-event-join').on('click', function () {
  window.location = privateEventJoinUrl;
});

privateEventCheckOverlay.$el.find('.cancel').on('click', function () {
  privateEventCheckOverlay.hide();
});

// build cover image
const $cover = $('.campaign__header .cover');
const $img = $cover.find('img');

if ($img.length) {
  $cover.css('background', `url('${$img.attr('src')}') no-repeat`).show();
  $cover.css('background-size', 'cover');
}

// add empty event if list contains an odd number
if ($('ul.event-list > li').length % 2 !== 0) {
  $('ul.event-list li:last-child').after('<li class="event empty"></li>');
}

// filter events
$('#event_filter').on('change', function () {
  window.location = `${window.location.pathname}?sort=${$(this).val()}#events`;
  return false;
});

const eventsTemplate = $('#row_template').text();
const moreEvents = [];
let eventsLength = 0;
const eventLimit = 20;

$('#see_more_events').on('click', function () {
  getCampaignEvents();
  return false;
});

function getCampaignEvents () {
  const data = {
    campaign_id: $('#campaign_id').val(),
    limit: eventLimit,
    offset: eventLimit + moreEvents.length,
    sort: $('#sort').val()
  };
  const $seeMoreButton = $('#see_more_events');
  let showSeeMoreButton = true;

  $.ajax({
    type: 'get',
    dataType: 'json',
    url: '/campaigns/more_events',
    data,
    beforeSend: function (xhr) {
      $seeMoreButton.prop('disabled', true);
      $seeMoreButton.hide();
      $seeMoreButton.wrap('<div class="small-spinner"></div>');
    },
    success: function (response, textStatus, jqXHR) {
      if (response.success) {
        const newEvents = response.results;
        let html = '';
        for (let i = 0; i < newEvents.length; i++) {
          moreEvents.push(newEvents[i]);
          html += Mustache.render(eventsTemplate, newEvents[i]);
        }
        eventsLength = eventLimit + moreEvents.length;
        if (eventsLength >= response.total_count) {
          showSeeMoreButton = false;
        }
        // append new events to list
        $('.campaign__events').find('ul').append(html);

        if (eventsLength % 2 !== 0) {
          $('ul.event-list li:last-child').after('<li class="event empty"></li>');
        }

        $('.private-event').off('click.private');
        $('.private-event').on('click.private', showPrivateEventWarning);
      } else {
        banner.showError('Uh oh! There was a problem completing your request. Please try again.', false, 4000);
      }
    },
    error: function (xhr) {
      banner.showError('Uh oh! There was a problem completing your request. Please try again.', false, 4000);
    },
    complete: function (xhr) {
      $seeMoreButton.unwrap();
      $seeMoreButton.prop('disabled', false);
      if (showSeeMoreButton) {
        $seeMoreButton.show();
      }
    }

  });
  return false;
}

// Assign event handlers for private event tooltip buttons.
$('.event-list .private-event-tooltip-button').each(function () {
  // Button - mouse enter event.
  $(this).unbind('mouseenter').bind('mouseenter', function () {
    const $this = $(this);
    const $popup = $('.private-event-tooltip-popoup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth = $popup.width();
      const popupHeight = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        display: 'block',
        top: buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        left: buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $(this).unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popoup').css('display', 'none');
  });
});
